import { createSlice } from "@reduxjs/toolkit";
import { fetchDailyLedger } from "./DailyLedgerThunk";

const initialState = {
  list: [],
  loading: false,
  filters: {
    fromDate: null,
    toDate: null,
  },
};

const dailyLedgerSlice = createSlice({
  name: "dailyLedger",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDailyLedger.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDailyLedger.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchDailyLedger.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setFilters } = dailyLedgerSlice.actions;
export default dailyLedgerSlice.reducer;
